export const getFileLink = filePath => {
  const fileLink = `${process.env.REACT_APP_BACKEND_URL}${filePath}`

  return fileLink
}
